import { createElement } from 'react';
import { Slider } from 'antd';
const SliderOuter = (props) => {
    const { range } = props;
    let { defaultValue } = props;
    if (range) {
        defaultValue = Array.isArray(defaultValue)
            ? defaultValue
            : [0, defaultValue];
    }
    else {
        defaultValue = Array.isArray(defaultValue)
            ? defaultValue[1] || defaultValue[0]
            : defaultValue;
    }
    return createElement(Slider, Object.assign({}, props, { defaultValue: defaultValue }));
};
export default SliderOuter;
